import Input from "../../components/Input/Input"
import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { showSnackBar } from "../../components/Snackbar/Snackbar"
import Button from "../../components/Button/Button"

import { NavLink, useNavigate } from "react-router-dom"
import { areFieldsNotEmpty } from "../../helpers/helper"
import { phoneNumber } from "../../utils/payment"
import { useMyContextLoading } from "../../components/LoadingContextProvider/LoadingContextProvider"
import ContainerPage from "../../components/ContainerPage/ContainerPage"
import PageTitle from "../../components/PageTitle/PageTitle"
import Calendar from "../../components/Calendar/Calendar"
import { StorageGetItem, USER } from "../../lib/storage"
import { createNewUsers, getAllUsersSubRolesDropdown } from "../../features/users/users"
import { clearListCache } from "../../utils/listCache"
import { fetchContactGroupsDropdownInfo } from "../../features/contactGroups/contactGroups"
import { validateEmail } from "../../helpers/validationEmail"
import Dropdown from "../../components/Dropdown/Dropdown"
import Card from "../../components/Card/Card"
import { dateToServer } from "../../utils/date"

const AddUsers = () => {
  const dispatch = useDispatch()
  const { triggerLoading } = useMyContextLoading()
  const [reqError, setReqError] = useState('')
  const [subRoles, setSubROles] = useState([])
  const [departments, setDepartments] = useState([])
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    company: '',
    dateOfBirth: ''
  })
  const [isFormValid, setIsFormValid] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    StorageGetItem(USER).then(result => {
      setFormData(prev => ({
        ...prev,
        company: result?.company || '',
      }))
    })
    getSubRoles()
    getDepartments()
  }, [])

  useEffect(() => {
    const handleReqError = () => {
      if (reqError && reqError?.length > 0) {
        showSnackBar("error", reqError)
      }
      setReqError('')
    }

    handleReqError();
  }, [reqError])


  const handleCreateUsers = async () => {
    let newNumber = formData?.primaryPhone
    triggerLoading(true)
    if (newNumber) {
      newNumber = formData.primaryPhone?.replace(/\D/g, "")
    }

    const response = await dispatch(createNewUsers({
      userData: {
        ...formData,
        primaryPhone: newNumber,
        dateOfBirth: dateToServer(formData.dateOfBirth),
      }
    }))
    if (response.error) {
      showSnackBar("error", response?.payload || 'Something went wrong')
    } else if (response) {
      showSnackBar("success", "Your changes are saved")
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        company: '',
      }
      )
      clearListCache('users')
      navigate("/users")
    }
    triggerLoading(false)
  }


  const handleInputChange = ({ name, value }) => {
    switch (name) {
      case 'primaryPhone':
        setFormData((prevData) => ({ ...prevData, [name]: phoneNumber(value) }))
        break
      default:
        const [parentField, childField] = name.split('.')
        if (childField) {
          setFormData((prevData) => ({
            ...prevData,
            [parentField]: {
              ...prevData[parentField],
              [childField]: value
            }
          }))
        } else {
          setFormData((prevData) => ({
            ...prevData,
            [name]: value
          }))
        }
        break
    }
  }

  const getSubRoles = async () => {
    triggerLoading(true)
    const response = await dispatch(getAllUsersSubRolesDropdown())
    if (response.error) {
      showSnackBar("error", response?.payload || "Something went wrong")
    } else {
      setSubROles(response?.payload?.data)
    }
    triggerLoading(false)
  }

  const getDepartments = async () => {
    const response = await dispatch(fetchContactGroupsDropdownInfo())
    if (response.error) {
      showSnackBar("error", response?.payload || "Something went wrong")
    } else {
      setDepartments(response?.payload?.data?.filter(group => group.isDepartment === true) || [])
    }
  }

  useEffect(() => {
    const checkFormValidity = () => {
      setIsFormValid(
        areFieldsNotEmpty([formData.firstName, formData.lastName, formData.email]) &&
        formData.dateOfBirth !== ""
      )
    }

    checkFormValidity()
  }, [formData])

  return (
    <ContainerPage>
      <div className="flex justify-between items-center">
        <PageTitle title="Create user" backTo="/users" />
      </div>
      <div className="flex  w-full items-center justify-center">
        <Card className="w-full max-w-[850px] p-12 border border-divider">
          <div className="grid grid-cols-2 gap-x-4 gap-y-6 pb-6 h-max border-b border-divider ">
            <Input
              width="w-full"
              placeholder="Enter First Name"
              label="First name *"
              value={formData.firstName}
              onChange={(e) => handleInputChange({ name: "firstName", value: e.target.value })}
            />
            <Input
              width="w-full"
              placeholder="Enter Last Name"
              label="Last name *"
              value={formData.lastName}
              onChange={(e) => handleInputChange({ name: "lastName", value: e.target.value })}
            />
            <Input
              type="email"
              width="w-full"
              placeholder="Enter Email"
              label="Email *"
              value={formData.email}
              onChange={(e) => handleInputChange({ name: "email", value: e.target.value })}
            />
            <Input
              width="w-full"
              placeholder="Enter Primary Phone"
              label="Primary Phone"
              value={formData.primaryPhone}
              onChange={(e) => handleInputChange({ name: "primaryPhone", value: e.target.value })}
            />
            <Calendar
              width="w-full"
              label="Date Of Birth *"
              height="56px"
              optional
              value={formData.dateOfBirth}
              onChange={(e) => handleInputChange({ name: "dateOfBirth", value: e })}
            />
            <Dropdown
              value={formData?.subRole}
              setValue={(e) => handleInputChange({ name: "subRole", value: e })}
              menuItems={subRoles}
              className="w-full mt-1"
              variant="standard"
              placeholder="Role"
              label="Role"
            />
            <Dropdown
              value={formData?.contactGroups?.[0] || ''}
              setValue={(e) => handleInputChange({ name: "contactGroups", value: e ? [e] : [] })}
              menuItems={departments}
              className="w-full mt-1"
              variant="standard"
              placeholder="Department"
              label="Department"
            />
          </div>
          <div className={`mt-6 flex justify-end space-x-4`}>
            <NavLink to={"/users"}>
              <Button classes={"mr-4"} onClick={() => {
              }} type="outlined" size="lg" width="min-w-[156px]">Close</Button>
            </NavLink>
            <Button
              onClick={handleCreateUsers}
              size="lg"
              width="min-w-[156px]"
              disabled={!isFormValid || !validateEmail(formData.email)}
              classes="rounded-lg"
            >
              Save
            </Button>
          </div>
        </Card>
      </div>
    </ContainerPage >

  )
}

export default AddUsers
